import { getBuildingCenter } from "./index210.js";
import { useCursor } from "./index211.js";
import { getWingPoly } from "./index213.js";
import { Shape as Shape$1 } from "./index216.js";
import { ScreenSizer, useFunction } from "@project-rouge/rg-three";
import { BackSide, MathUtils, Vector3 } from "three";
import { memo, useMemo, useState } from "react";
import { Billboard, Line as Line$1, Plane } from "@react-three/drei";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const SelectWingButton = memo(({ building, bone, onClick, topOffset, readonly }) => {
	const position = useMemo(() => {
		const pos = getBuildingCenter(building, bone);
		pos[1] *= 2;
		pos[1] += topOffset;
		return pos;
	}, [
		building,
		bone,
		topOffset
	]);
	const wingPoly = useMemo(() => getWingPoly({
		building,
		bone,
		level: bone.floors - 1,
		skipCornerCores: true
	}), [building, bone]);
	const wingPolyWithCornerCores = useMemo(() => getWingPoly({
		building,
		bone,
		level: bone.floors - 1
	}), [building, bone]);
	const [hover, setHover] = useState(false);
	useCursor(hover);
	const onPointerOver = useFunction((e) => {
		if (!hasPriority(e)) {
			if (hover) setHover(false);
			return;
		}
		if (!hover) setHover(true);
	});
	const onPointerOut = useFunction(() => {
		if (hover) setHover(false);
	});
	const _onClick = useFunction((e) => {
		if (!hasPriority(e)) return;
		e.stopPropagation();
		onClick(bone);
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [!readonly && /* @__PURE__ */ jsx(Icon, {
		position,
		hover
	}), /* @__PURE__ */ jsx(Top, {
		position,
		wingPoly,
		wingPolyWithCornerCores,
		onClick: _onClick,
		onPointerMove: onPointerOver,
		onPointerOut,
		readonly
	})] });
});
SelectWingButton.displayName = "SelectWingButton";
var vector3 = new Vector3();
function hasPriority(e) {
	const intersections = e.intersections.filter((i) => i.object.userData.wingCenter);
	let closestObj = intersections[0].object;
	vector3.fromArray(closestObj.userData.wingCenter);
	let closestDistSq = vector3.distanceToSquared(e.point);
	for (let i = 1; i < intersections.length; i++) {
		const obj = intersections[i].object;
		vector3.fromArray(obj.userData.wingCenter);
		const distSq = vector3.distanceToSquared(e.point);
		if (distSq >= closestDistSq) continue;
		closestObj = obj;
		closestDistSq = distSq;
	}
	return closestObj === e.object;
}
var Top = ({ position, wingPoly, wingPolyWithCornerCores, onClick, onPointerMove, onPointerOut, readonly }) => /* @__PURE__ */ jsxs("object3D", {
	position: [
		0,
		position[1],
		0
	],
	rotation: [
		90 * MathUtils.DEG2RAD,
		0,
		0
	],
	children: [
		/* @__PURE__ */ jsx(Shape$1, {
			points: wingPolyWithCornerCores,
			"material-side": BackSide,
			"material-depthTest": false,
			"material-depthWrite": false,
			visible: false,
			onClick: !readonly ? onClick : void 0,
			onPointerMove: !readonly ? onPointerMove : void 0,
			onPointerOut: !readonly ? onPointerOut : void 0,
			userData: { wingCenter: position }
		}),
		/* @__PURE__ */ jsx(Shape$1, {
			points: wingPoly,
			"material-side": BackSide,
			"material-transparent": true,
			"material-opacity": .5
		}),
		/* @__PURE__ */ jsx(Line$1, {
			points: wingPoly,
			transparent: true,
			color: "#3B3B5F"
		})
	]
});
var Icon = ({ position, hover }) => {
	const size = !hover ? 8 : 10;
	const halfSize = size * .5;
	const points = useMemo(() => [
		[
			-halfSize,
			0,
			-halfSize
		],
		[
			halfSize,
			0,
			-halfSize
		],
		[
			halfSize,
			0,
			halfSize
		],
		[
			-halfSize,
			0,
			halfSize
		],
		[
			-halfSize,
			0,
			-halfSize
		]
	], [size]);
	return /* @__PURE__ */ jsx(ScreenSizer, {
		position,
		children: /* @__PURE__ */ jsxs(Billboard, {
			position: [
				0,
				5,
				0
			],
			children: [/* @__PURE__ */ jsx(Plane, {
				args: [size, size],
				"material-color": !hover ? "#ffffff" : "#3B3B5F"
			}), /* @__PURE__ */ jsx(Line$1, {
				points,
				color: !hover ? "#60666C" : "#9E9ED1",
				rotation: [
					-90 * MathUtils.DEG2RAD,
					0,
					0
				]
			})]
		})
	});
};
export { SelectWingButton };

//# sourceMappingURL=index219.js.map